
export default class HouseType {
  constructor() {
    this.id = null;
    this.name = null;
    this.icon = "mdi-floor-plan";

    this.defaultRooms = [];
  }
}
